import { render, staticRenderFns } from "./titleComponent.vue?vue&type=template&id=99d41196"
import script from "./titleComponent.vue?vue&type=script&lang=js"
export * from "./titleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports